import React, { useState, useRef } from "react";
import "./style.scss";
import StaffHeader from "../CommonComponents/StaffHeader";
import StaffDashboardRightContent from "./rightContainer";
import StaffDashboardLeftContent from "./leftContainer";
import { Popover, OverlayTrigger } from "react-bootstrap";
// import { StaffContextProvider } from "../StaffContext";
// import PageHeading from "../CommonComponents/PageHeader/page-header";
// import JoyRides from "../../UI Component/JoyRide/JoyRide";
// import * as Steps from "../../UI Component/JoyRide/constants";
import useWindowSize from "../../../Hooks/useWindowSize";
import DownloadReport from "../../DownloadReport/DownloadReport";
import DashboardAppointmentsView from "../../DashboardAppointmentsView";

const Overlay = (props) => {
  const popover = (
    <Popover id="my-popover" placement={props.placement}>
      <Popover.Title>Title One</Popover.Title>
      <Popover.Content>Test Content</Popover.Content>
    </Popover>
  );
  return popover;
};

function InfoIcon(props) {
  return (
    <svg {...props} viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
      <path d="M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" />
    </svg>
  );
}

const StaffDashboard = (props) => {
  const [showJoyride, setShowJoyride] = useState(false);
  const size = useWindowSize();
  const joyrideToggle = () => setShowJoyride(!showJoyride);
  const scrollRef = useRef(null);
  return (
    <>
      <div className="container-fluid p-0">
        <div
          style={{
            borderBottom: "1px solid #d6dae5",
            borderTop: "1px solid #d6dae5",
            display: "flex",
            boxShadow: "0 2px 5px 2px rgb(0, 0, 0, 0.1)",
            marginBottom: size.width < 800 ? "20px" : "0",
          }}
        >
          <StaffHeader
            isPageHeading={false}
            joyrideToggle={joyrideToggle}
            headerText={localStorage.getItem("full_name")}
            homeClick={() => {
              props.history.push("/");
            }}
          />
        </div>

        {/* <PageHeading text={"DASHBOARD"} /> */}
        <div className="row dashboard-container m-0">
          <div
            className="col-lg-9 col-12 p-0 dashboard-left-container"
            style={{
              height: window.innerWidth > 767 ? "calc(100vh - 78px)" : "",
            }}
          >
            <DashboardAppointmentsView
              callNextAppointmentWidget={props.callNextAppointmentWidget}
            />
            {/* <StaffDashboardLeftContent /> */}

            {/* <div style={{ textAlign: "center", position: "relative" }}>
              <OverlayTrigger
                placement="bottom"
                overlay={<Overlay />}
                trigger="hover"
              >
                <InfoIcon width="20px" height="20px" />
              </OverlayTrigger>
            </div> */}
          </div>
          <div
            ref={scrollRef}
            className={
              "col-lg-3 col-12 p-0 dashboard-right-container " +
              (window.innerWidth < 767 ? "pb-5" : "")
            }
            style={{
              height: window.innerWidth > 767 ? "calc(100vh - 78px)" : "",
            }}
          >
            <StaffDashboardRightContent scrollRef={scrollRef} />
          </div>
        </div>
      </div>
      {/* <DownloadReport /> */}
    </>
  );
};

export default StaffDashboard;
